(() => {
    const selector = '.productView-upsell__form';
    const sliderSelector = '[data-product-upsell-slider]';

    const toBoolean = (value) => value === true || value === 'true';

    const initUpsellSliders = () => {
        if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;

        window.jQuery(sliderSelector).each((index, slider) => {
            const $slider = window.jQuery(slider);

            if ($slider.hasClass('slick-initialized')) return;

            const itemToShow = Number(slider.dataset.itemToShow) || 2;
            const showArrows = toBoolean(slider.dataset.itemArrows);
            const showDots = toBoolean(slider.dataset.itemDots);

            $slider.slick({
                mobileFirst: true,
                infinite: false,
                adaptiveHeight: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: showDots,
                nextArrow: window.arrows?.icon_next,
                prevArrow: window.arrows?.icon_prev,
                rtl: window.rtl_slick,
                responsive: [
                    {
                        breakpoint: 550,
                        settings: {
                            slidesToShow: Math.min(2, itemToShow),
                            slidesToScroll: Math.min(2, itemToShow),
                            arrows: showArrows,
                            dots: showDots
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: itemToShow,
                            slidesToScroll: itemToShow,
                            arrows: showArrows,
                            dots: showDots
                        }
                    }
                ]
            });
        });
    };

    const refreshCartSidebar = (cart, root) => {
        const sidebar = document.querySelector('#halo-cart-sidebar');
        const wrapper = sidebar?.querySelector('.previewCart-wrapper');

        document.body.classList.add('cart-sidebar-show');

        document.querySelectorAll('[data-cart-count]').forEach((element) => {
            element.textContent = cart.item_count;
        });

        document.querySelectorAll('[data-cart-text]').forEach((element) => {
            if (window.cartStrings) {
                element.textContent = cart.item_count === 1 ? window.cartStrings.item : window.cartStrings.items;
            }
        });

        if (!wrapper) return Promise.resolve();

        wrapper.classList.add('is-loading');

        return fetch(`${root}cart?view=ajax_side_cart`)
            .then((response) => response.text())
            .then((html) => {
                wrapper.innerHTML = html;
                document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
            })
            .finally(() => {
                wrapper.classList.remove('is-loading');
            });
    };

    document.addEventListener('submit', (event) => {
        const form = event.target.closest(selector);

        if (!form) return;

        event.preventDefault();

        const button = form.querySelector('[data-product-upsell-atc]');
        const formData = new FormData(form);
        const root = window.Shopify?.routes?.root || window.routes?.root || '/';

        button?.setAttribute('disabled', 'disabled');
        button?.classList.add('is-loading');

        fetch(`${root}cart/add.js`, {
            method: 'POST',
            body: formData
        })
            .then((response) => {
                if (!response.ok) {
                    return response.json().then((error) => Promise.reject(error));
                }

                return response.json();
            })
            .then(() => {
                return fetch(`${root}cart.js`)
                    .then((response) => response.json())
                    .then((cart) => refreshCartSidebar(cart, root));
            })
            .catch((error) => {
                if (window.showWarning) {
                    window.showWarning(error.description || error.message || error);
                } else {
                    console.error(error);
                }
            })
            .finally(() => {
                button?.classList.remove('is-loading');
                button?.removeAttribute('disabled');
            });
    });

    document.addEventListener('DOMContentLoaded', initUpsellSliders);
    document.addEventListener('shopify:section:load', initUpsellSliders);
    window.addEventListener('load', initUpsellSliders);
})();
